export const generateId = (data: Array<any>) => {
  if (data.length === 0) {
    return 0;
  } else {
    return Number(data[data.length - 1].id) + 1;
  }
};